/* eslint-disable */
import bi1_data_validation from '../../base_i1_datavalidation'
import { RC, CR, AJRS } from '../../base_i2_success_codes'
import base_i3_log from '../../base_i3_logging'
import { ajax } from 'noquery-ajax'

function logUserControlInterfaceActivationRequest(user_uid, firebase_email, firebase_token, cicp_uid) {
  return new Promise(function (resolve, reject) {
    let return_msg = "";
    const debug_data = [];
    let call_result = {};
    const task_id = "p1s6t2_logUserControlInterfaceActivationRequest"

    ///// input validation
    call_result = bi1_data_validation.is_email_address(firebase_email);
    debug_data.push(call_result);
    call_result = bi1_data_validation.is_string(user_uid);
    debug_data.push(call_result);
    call_result = bi1_data_validation.is_string(firebase_token);
    debug_data.push(call_result);
    call_result = bi1_data_validation.is_string(cicp_uid);
    debug_data.push(call_result);

    let validation_failed_flag = false;
    for (let index in debug_data) {
      if (debug_data[index][CR.success] !== RC.success) {
        validation_failed_flag = true;
        break;
      }
    }

    if (validation_failed_flag === true) {
      return_msg += "input validation failed";
      base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
      reject({ success: RC.input_validation_failed, return_msg: return_msg, debug_data: debug_data });
      return;
    }
    /////</end> input validation

    ajax({
      url: `${window.G_p1s6_tasks_domain}/p1s6t2-log-user-control-interface-activation-request`,
      method: 'POST',
      dataType: "JSON",

      data: {
        'user_uid': user_uid,
        'firebase_email': firebase_email,
        'firebase_token': firebase_token,
        'p1s6t2_control_interface_uid': cicp_uid,
      },
      success: function (result) {
        resolve({ success: RC.success, return_msg: return_msg, debug_data: debug_data});
      },
      error: function (result) {
        if (result.status === 401) {
          window.G_firebase_auth.bi5forceTokenRefresh();
        }
        return_msg += "failed to log user control interface activation request, error data:" + JSON.stringify(result);
        base_i3_log(G_username, G_ip, G_page_id, task_id, RC.ajax_failure, return_msg, debug_data);
        reject({ success: RC.general_failure, return_msg: return_msg, debug_data: debug_data});
      }
    })
  });
};

export default logUserControlInterfaceActivationRequest


// WEBPACK FOOTER //
// ./src/watchdog_includes/json_tasks/p1s6/p1s6t2.js